import axiosInstance from "api/axios";
import { UserForm } from "types/dialog/userFormDialog.type";
import { User } from "types/user.type";

export const userService = {
  getAll: async () => {
    const response = await axiosInstance.get("/user");
    return response.data;
  },

  getFilterUsers: async () => {
    const response = await axiosInstance.get("/user/filter-users");
    return response.data;
  },

  getById: async (id: number) => {
    const response = await axiosInstance.get(`/user/${id}`);
    return response.data;
  },

  create: async (data: UserForm | Partial<User>) => {
    const response = await axiosInstance.post("/user", data);
    return response.data;
  },

  update: async (id: number, data: FormData | Partial<User>) => {
    const isFormData = data instanceof FormData;

    const response = await axiosInstance.put(`/user/${id}`, data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    });
    return response.data;
  },

  delete: async (id: number) => {
    const response = await axiosInstance.delete(`/user/${id}`);
    return response.data;
  },
};
